const data = {
    id : {
        title    : "Hubungi Kami",
        subTitle : "Bimbingan belajar ETC menggunakan modul khusus berlisensi ISBN serta Try out berbasis sistem CAT."
    }
}

export default data;